export const personalInfo = {
  name: "Satya Prakash Dubey",
  shortName: "S. P. Dubey",
  title: "Microbiologist | Quality Control Officer",
  subtitle: "4+ Years in Pharmaceutical QC · cGMP Compliance · Sterility Assurance",
  email: "satyamdubey558@gmail.com",
  phone: "+91 9873190250",
  location: "Panchkula, Haryana, India – 134109",
  linkedin: "https://www.linkedin.com/in/satya-prakash-dubey-7456b8176/",
  bio: "Dedicated Microbiologist with over 4 years of hands-on experience in pharmaceutical Quality Control. Expertise in environmental monitoring, microbial limit testing, and sterility assurance. Committed to ensuring cGMP compliance and the delivery of safe, high-quality pharmaceutical products.",
};

export const experience = [
  {
    id: 1,
    role: "Officer – Microbiology (Quality Control)",
    company: "Aristo Pharmaceuticals Private Limited",
    location: "Baddi, Himachal Pradesh",
    duration: "June 2024 – Present",
    type: "Full-time",
    current: true,
    description: [
      "Executing microbial limit testing of purified water, raw water, and water for injection",
      "Conducting environmental monitoring and preparing EM & water trend reports",
      "Performing bioburden testing and bacterial endotoxin tests as per cGMP guidelines",
      "Maintaining laboratory documents, log books, and online records with GDP compliance",
      "Calibration and daily verification of instruments including weighing balances and pH meters",
    ],
  },
  {
    id: 2,
    role: "Officer – Microbiology (Quality Control)",
    company: "Scott-Edil Pharmacia Limited",
    location: "Baddi, Himachal Pradesh",
    duration: "Nov 2022 – May 2024",
    type: "Full-time (1.6 Years)",
    current: false,
    description: [
      "Performed microbial limit tests on finished products, raw materials, and specific pathogens",
      "Handled culture preparation, growth promotion tests, and media preparation & documentation",
      "Operated laminar air flow units, vertical autoclave, and colony counters",
      "Monitored liquid-borne particle counters and maintained instrument calibration records",
      "Ensured strict adherence to GLP, GMP, and safety reporting protocols",
    ],
  },
  {
    id: 3,
    role: "Trainee Officer – Microbiology (Quality Control)",
    company: "Zeiss Pharma Limited",
    location: "Samba, Jammu & Kashmir",
    duration: "May 2022 – Nov 2022",
    type: "Trainee (0.5 Years)",
    current: false,
    description: [
      "Gained hands-on training in pharmaceutical QC microbiology testing procedures",
      "Assisted in environmental monitoring, microbial limit testing, and documentation",
      "Operated BOD incubators, bacteriological incubators, and microscopes",
      "Learned and implemented Good Laboratory Practices (GLP) and cGMP standards",
    ],
  },
  {
    id: 4,
    role: "Marketing Executive",
    company: "AIMIL Pharmaceuticals Limited",
    location: "Delhi",
    duration: "July 2021 – Oct 2021",
    type: "Full-time (0.3 Years)",
    current: false,
    description: [
      "Promoted pharmaceutical and herbal health products to healthcare professionals",
      "Developed communication and interpersonal skills in a professional pharma setting",
      "Identified market opportunities and built relationships with medical professionals",
    ],
  },
];

export const responsibilities = [
  { title: "Microbial Limit Test", desc: "Purified water, raw water analysis, and specific pathogens detection", icon: "🧫" },
  { title: "Water for Injection Testing", desc: "MLT of WFI and pure steam condensate as per pharmacopeial standards", icon: "💉" },
  { title: "Finished Product Testing", desc: "MLT of finished products, raw materials, and specific pathogen screening", icon: "🧪" },
  { title: "Bioburden Testing", desc: "Assessment of microbial contamination in pharmaceutical products & environments", icon: "🔬" },
  { title: "Environmental Monitoring", desc: "EM of controlled areas, air sampling, surface monitoring & trend analysis", icon: "🌡️" },
  { title: "Bacterial Endotoxin Test", desc: "LAL-based endotoxin testing for parenteral products per USP/EP standards", icon: "⚗️" },
  { title: "Media Preparation & GPT", desc: "Preparation, documentation of media and growth promotion tests for culture validation", icon: "🧬" },
  { title: "Instrument Calibration", desc: "Daily calibration and maintenance records for lab instruments as per GMP", icon: "⚖️" },
  { title: "Trend Preparation", desc: "Preparation and analysis of EM and water monitoring trend data for QA review", icon: "📊" },
  { title: "Liquid Particle Counter", desc: "Operation of liquid-borne particle counters for water and environment assessment", icon: "💧" },
  { title: "Lab Documentation", desc: "Maintenance of log books, reports, and online records per GDP guidelines", icon: "📋" },
  { title: "Protocol Management", desc: "Writing and reviewing SOPs, protocols, and safety documentation", icon: "📄" },
];

export const instruments = [
  "Laminar Air Flow (LAF)",
  "Weighing Balance (Calibration & Verification)",
  "pH Meter (Calibration & Daily Verification)",
  "Hot Air Oven",
  "Heating Block",
  "BOD Incubator",
  "Bacteriological Incubator",
  "Vertical Autoclave",
  "Microscope",
  "Colony Counter",
  "Liquid-borne Particle Counter",
];

export const skills = {
  technical: [
    "Microbial Limit Testing (MLT)",
    "Environmental Monitoring (EM)",
    "Bioburden Testing",
    "Bacterial Endotoxin Test (BET/LAL)",
    "Sterility Assurance",
    "Water Quality Testing",
    "Culture Preparation",
    "Growth Promotion Test (GPT)",
  ],
  compliance: [
    "cGMP Compliance",
    "GLP (Good Laboratory Practices)",
    "GDP (Good Documentation Practices)",
    "Safety Reporting",
    "Protocol Management",
    "SOP Writing & Review",
  ],
  soft: [
    "Team Leadership & Mentoring",
    "Time Management",
    "MS Word & Excel",
    "Inter-personal Communication",
    "Problem Solving & Innovation",
    "Training & Development",
  ],
};

export const education = [
  {
    degree: "Bachelor of Technology – Biotechnology",
    institution: "IILM College of Engineering & Technology",
    location: "Greater Noida, UP",
    year: "2021",
    grade: "GPA: 6.5 / 10",
    board: "AKTU",
  },
  {
    degree: "Intermediate (12th) – Science",
    institution: "SVM Inter College",
    location: "Uttar Pradesh",
    year: "2016",
    grade: "79.9% – UP Board",
    board: "UP Board",
  },
  {
    degree: "High School (10th)",
    institution: "SVM High School",
    location: "Uttar Pradesh",
    year: "2014",
    grade: "81.3% – UP Board",
    board: "UP Board",
  },
];

export const stats = [
  { value: "4+", label: "Years Experience" },
  { value: "3+", label: "Pharma Companies" },
  { value: "12+", label: "QC Responsibilities" },
  { value: "11+", label: "Instruments Handled" },
];
